import React, { useState } from "react";
import VasaChat from "@/pages/aulelo/VasaChat";
import NotesPanel from "@/pages/aulelo/NotesPanel";

export default function AuleloVasa() {
  const [tab, setTab] = useState("notes");

  return (
    <div className="space-y-6" data-testid="aulelo-vasa-page">
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-emerald-400">// vasa · notes companion</div>
        <h1 className="font-mono text-4xl md:text-5xl font-black tracking-tight mt-2 text-emerald-50">Your memory, distilled.</h1>
        <p className="text-zinc-400 mt-2 font-mono text-sm">Rich notes + a research companion that quotes your past entries back to you.</p>
      </div>

      <div className="grid lg:grid-cols-[1fr_420px] gap-px bg-emerald-900/20 border border-emerald-900/30">
        <div className="bg-black p-5">
          <div className="flex gap-1 mb-4 border-b border-emerald-900/40 pb-2">
            <button onClick={() => setTab("notes")} data-testid="vasa-tab-notes"
              className={`font-mono text-[11px] uppercase tracking-[0.2em] px-3 py-1.5 border ${
                tab === "notes" ? "border-emerald-500 bg-emerald-500/10 text-emerald-200" : "border-zinc-800 text-zinc-500 hover:text-emerald-300"
              }`}>my notes</button>
            <button onClick={() => setTab("glean")} data-testid="vasa-tab-glean"
              className={`font-mono text-[11px] uppercase tracking-[0.2em] px-3 py-1.5 border ${
                tab === "glean" ? "border-amber-500 bg-amber-500/10 text-amber-200" : "border-zinc-800 text-zinc-500 hover:text-amber-300"
              }`}>chosen · vasa-glean</button>
          </div>
          {tab === "notes" ? (
            <NotesPanel scopeLabel="My notes — all" />
          ) : (
            <GleanList />
          )}
        </div>
        <div className="bg-black p-5">
          <VasaChat tags={tab === "glean" ? ["vasa-glean"] : null} />
        </div>
      </div>
    </div>
  );
}

import { useEffect } from "react";
import { auleloApi } from "@/lib/auleloApi";
import { Sparkles, ExternalLink, Trash2 } from "lucide-react";
import { toast } from "sonner";

function GleanList() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => {
    try {
      const { data } = await auleloApi.get("/vasa/notes?source=vasa-glean");
      setItems(data || []);
    } catch {/* */}
  })(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this glean?")) return;
    try {
      await auleloApi.delete(`/vasa/notes/${id}`);
      setItems((s) => s.filter((x) => x.id !== id));
    } catch { toast.error("Delete failed"); }
  };

  return (
    <div className="space-y-3" data-testid="vasa-glean-list">
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-400">// chosen · fact-checked</div>
      {items.length === 0 && (
        <div className="border border-dashed border-amber-900/40 p-10 text-center text-zinc-500 font-mono text-sm">
          No gleans yet. Use <b className="text-amber-300">Glean & cross-check</b> from the Aulelo briefing on any article you choose.
        </div>
      )}
      {items.map((n) => (
        <article key={n.id} className="border border-amber-900/30 bg-black p-4" data-testid={`glean-${n.id}`}>
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1 min-w-0">
              <div className="font-mono text-[10px] uppercase tracking-widest text-amber-400 flex items-center gap-2">
                <Sparkles className="w-3 h-3" /> {String(n.updated_at).slice(0, 16).replace("T", " · ")}
              </div>
              <h3 className="font-mono text-base font-bold text-amber-100 mt-1 line-clamp-2">{n.title}</h3>
            </div>
            <div className="flex gap-1">
              {n.external_url && (
                <a href={n.external_url} target="_blank" rel="noreferrer" className="p-1.5 border border-zinc-800 text-zinc-400 hover:text-amber-300">
                  <ExternalLink className="w-3 h-3" />
                </a>
              )}
              <button onClick={() => del(n.id)} className="p-1.5 border border-zinc-800 text-zinc-400 hover:text-red-400">
                <Trash2 className="w-3 h-3" />
              </button>
            </div>
          </div>
          <div className="mt-3 prose prose-invert prose-sm max-w-none font-mono text-[13px] text-zinc-300"
            dangerouslySetInnerHTML={{ __html: n.body_html }} />
        </article>
      ))}
    </div>
  );
}
